export default "__VITE_PUBLIC_ASSET__d2dc1ae9__"